import React, { Component, Fragment } from 'react';
import { NavLink } from 'react-router-dom';
import * as helper from '../../utils/helper';
import { LoaderScreen, ProductBox, DotLoader } from '../common';
import isEqual from 'lodash/isEqual';
import isEmpty from 'lodash/isEmpty';
import styles from './styles.scss';
import * as print from 'print';
import Snackbar from './../common/Snackbar';

const asnFilterOptionsArr = [
    {
        id: 1,
        filter: 'All Products',
        po_description: 'All',
    },
    {
        id: 2,
        filter: 'ASN Products',
        po_description: 'ASN',
    },
];
export default class Search extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            asn: [],
            error: null,
            filterText: '',
            filterKeywords: [],
            filteredResults: [],
            resultsLayout: 'image',
            productFilterDropdown: false,
            asnFilterOption: 'All',
            bulkloading: false,
            searching:false,
        };
        this.emptyFilters = this.state.filterParams;
    }

    doLoad = () => {
        const { data } = this.props;

        if (!isEmpty(data)) {
            this.setState({ data: data, filteredResults: data.lines });
        }
    };

    componentDidMount() {
        this.run(this.doLoad);
    }

    componentDidUpdate(prevProps) {
        const { data } = this.props;
        if (!isEqual(data, prevProps.data)) {
            this.run(this.doLoad);
        }
    }

    run = fn => {
        this.setState({ loading: true });
        try {
            const ret = fn();
            this.setState({ loading: false });
            return ret;
        } catch (e) {
            helper.error(e);
            this.setState({ loading: false });
        }
    };

    resetFilters = () => {
        document.getElementsByName("gtin")[0].value='';
        this.setState({ filteredResults: this.props.data.lines,filterText:'' });
    };

    handleChange = evt => {
        const input = evt.target.name;
        const val = evt.target.value;

        this.setState(
            prevState => {
                return {
                    filterText: val,
                    filterKeywords: this.convertToArr(val), // <- To convert string separated with commas to an array.
                };
            },
            () => {
                this.filterResults();
            },
        );
    };


    onKeyUp = evt => {
        // if (["Backspace", "Delete"].indexOf(evt.key) !== -1 && !evt.target.value) {
        //     this.setState({ filteredResults: this.props.data.lines });
        //     return
        // }
        if (evt.key === "Enter" && evt.target.value) {
            this.setState({ searching:true})
            const val = evt.target.value;
            this.setState(
                prevState => {
                    return {
                        filterKeywords: this.convertToArr(val)
                    } // <- To convert string separated with commas to an array.,
                },
                () => {
                    this.filterResults();
                },
            );
        }
    };

    convertToArr = value => {
        const arr = value.split(',');

        // To avoid adding an empty string as the next array item as soon as the comma(,) is typed
        if (arr.length > 1 && arr[arr.length - 1] === '') {
            return arr.slice(0, -1);
        }
        return arr;
    };

    filterResults = (setAsnFilter = false) => {
        const { data, filterKeywords } = this.state;

        let results = data.lines;
        const propertiesToCheck = ['barcode', 'family', 'gtin', 'model_name_number', 'partner_sku', 'po_description', 'title_en', 'variant_en','brand_code'];

        if (filterKeywords.length === 0) {
            this.setAsnFilter(results);
            return
        }
        else if (filterKeywords.length === 1) {
            const filterFunc = item => {
                for (let i = 0; i < propertiesToCheck.length; i++) {
                    const property = propertiesToCheck[i]
                    if (
                        item.hasOwnProperty(property) &&
                        item[property] &&
                        item[property]
                            .toString()
                            .toLowerCase()
                            .indexOf(filterKeywords[0].toString().toLowerCase()) > -1
                    ) {
                        return true;
                    }
                }
                return false;
            };
            results = results.filter(filterFunc);
        }
        else {
            filterKeywords.forEach(keyword => {
                const filterFunc = item => {
                    for (let i = 0; i < propertiesToCheck.length; i++) {
                        const property = propertiesToCheck[i]
                        if (
                            item.hasOwnProperty(property) &&
                            item[property] &&
                            item[property]
                                .toString()
                                .toLowerCase()
                                .indexOf(keyword.toString().toLowerCase()) > -1
                        ) {
                            return true;
                        }
                    }
                    return false;
                };
                results = results.filter(filterFunc);
            });
        }

        if (setAsnFilter) {
            this.setAsnFilter(results);
        } else {
            this.setState({ filteredResults: results, searching: false });
        }
        this.setState({ searching: false });
    };

    toggleDropdown = () => {
        this.setState(prevState => ({
            productFilterDropdown: !prevState.productFilterDropdown,
        }));
    };

    setAsnFilter = data => {
        const { asnFilterOption } = this.state;

        let results = '';
        if (asnFilterOption !== 'All') {
            results = data.filter(item => {
                return item.po_description.includes('ASN');
            });
        }

        this.setState({
            filteredResults: results ? results : data,
        });
    };

    setFilter = poDescription => {
        this.setState(
            {
                asnFilterOption: !poDescription ? '' : poDescription,
                productFilterDropdown: false,
            },
            () => {
                this.filterResults(true);
            },
        );
    };

    renderProductFilter = () => {
        return (
            <ul>
                {asnFilterOptionsArr.map(filterOption => (
                    <li
                        id={filterOption.id}
                        className={`${styles.filterOption} ${this.state
                            .asnFilterOption === filterOption.po_description &&
                            styles.selected}`}
                    >
                        <a
                            onClick={() =>
                                this.setFilter(filterOption.po_description)
                            }
                        >
                            {filterOption.filter}
                        </a>
                    </li>
                ))}
            </ul>
        );
    };

    renderFilterBar = filterText => {
        const { productFilterDropdown, asnFilterOption } = this.state;
        const { data } = this.props;
        const largeAsn = !window.location.pathname.includes('/asn/')
        const idPartner = data.lines && data.lines[0] ? data.lines[0].partner_bm : 0;
        return (
            <div className={styles.filterArea}>
                <div className={styles.searchInput}>
                    {
                        largeAsn ? 
                            <input
                                placeholder="Search by barcode, SKU, product title, variant, family, brand model no, GTIN, PO description, ASN Identifier and partner SKU "
                                name="gtin"
                                type="text"
                                onKeyUp={(evt) => this.onKeyUp(evt)}
                            /> :
                            <input
                                value={filterText}
                                placeholder="Search by barcode, SKU, product title, variant, family, brand model no, GTIN, PO description, ASN Identifier and partner SKU "
                                name="gtin"
                                type="text"
                                onChange={evt => this.handleChange(evt)}
                            />
                    }
                </div>
                <div>
                    <button onClick={this.resetFilters}>Reset</button>
                </div>
                <NavLink
                    className={styles.advancedSeachOpt}
                    to={`/partner/${idPartner}`}
                >
                    Advanced
                </NavLink>
                <a className={styles.asnFilter} onClick={this.toggleDropdown}>
                    <div>
                        <label className={styles.filterProductLabel}>
                            FILTER PRODUCTS
                        </label>
                        <label className={styles.asnLabel}>
                            {
                                asnFilterOptionsArr.find(
                                    o => o.po_description === asnFilterOption,
                                ).filter
                            }
                        </label>
                    </div>
                    <i className="icon-chevron-down" />
                </a>
                {productFilterDropdown && (
                    <div className={styles.dropdownContainer}>
                        {this.renderProductFilter()}
                    </div>
                )}
            </div>
        );
    };

    bulkPrint = () => {
        this.setState({ bulkloading: true })
        try {
            const { data: { lines } } = this.props;
            const labels = lines.reduce((acc, current) => {
                acc.push(
                    print.generateLabel({ ...current, qty: current.po_qty || 1, label: (current.title_en).trim() }),
                    print.generateLabel({ barcode: '', id_partner: '', pbarcode: '', qty: 1, label: '-- ✂ - CUT HERE - ✂ --' })
                )
                return acc
            }, [])
            print.print(labels);
        }
        catch (e) {
            this.setState({ err: true, msg: `Something went wrong` });
            setTimeout(() => this.setState({ err: false }),5000)
        }
        this.setState({ bulkloading: false })
    };

    render() {
        const {
            filteredResults,
            filterText,
            resultsLayout,
            loading,
            bulkloading,
            err, msg, searching
        } = this.state;
        if (loading) {
            return <LoaderScreen />;
        }
        return (
            <div>
                {/* HEADER/FILTER START */}
                <div className={styles.header}>
                    <label>Start Searching a Product</label>
                    <button className={styles.primaryCta} disabled={bulkloading} onClick={() => this.bulkPrint()}>
                        {bulkloading ? <DotLoader/> : "Bulk Print"}
                    </button>
                </div>
                {this.renderFilterBar(filterText)}
                {/* HEADER/FILTER END */}

                {/* RESULTS START */}
                {
                    searching ?
                    <DotLoader /> :
                    <Fragment>
                        <div className={styles.resultsHeader}>
                            <p>{filteredResults.length} results found</p>
                            {filteredResults.length > 0 && (
                                <div className={styles.viewSwitcherContainer}>
                                    <button
                                        className={
                                            resultsLayout === 'image'
                                                ? styles.active
                                                : null
                                        }
                                        onClick={() =>
                                            this.setState({ resultsLayout: 'image' })
                                        }
                                    >
                                        Image View
                                </button>
                                    <button
                                        className={
                                            resultsLayout === 'table'
                                                ? styles.active
                                                : null
                                        }
                                        onClick={() =>
                                            this.setState({ resultsLayout: 'table' })
                                        }
                                    >
                                        Table View
                                </button>
                                </div>
                            )}
                        </div>
                        {filteredResults.length > 0 && (
                            <div
                                className={`${styles.productList} ${
                                    styles[resultsLayout]
                                    }`}
                            >
                                {filteredResults.map(
                                    (line, index) =>
                                        resultsLayout === 'image' ? (
                                            <div
                                                className={styles.productBoxContainer}
                                                key={index + line.partner_sku}
                                            >
                                                <ProductBox
                                                    layout={resultsLayout}
                                                    item={line}
                                                    printLabel={this.props.printLabel}
                                                />
                                            </div>
                                        ) : (
                                                <ProductBox
                                                    layout={resultsLayout}
                                                    item={line}
                                                    printLabel={this.props.printLabel}
                                                    key={index + line.partner_sku}
                                                />
                                            ),
                                )}
                            </div>
                        )}
                    </Fragment>
                }
                {
                    err  ?
                        <Snackbar msg={msg} /> : ''
                }
                {/* RESULTS END */}
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Search/index.js